import { render, staticRenderFns } from "./PedidoProdutosExpandido.vue?vue&type=template&id=7e0bcffb&scoped=true"
import script from "./PedidoProdutosExpandido.vue?vue&type=script&lang=js"
export * from "./PedidoProdutosExpandido.vue?vue&type=script&lang=js"
import style0 from "./PedidoProdutosExpandido.vue?vue&type=style&index=0&id=7e0bcffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0bcffb",
  null
  
)

export default component.exports